export const environment = {
  production: true,
  apiUrl: '/graphql',
  newAdminBidsUrl: 'https://admin.carvector.com/auctions/bids',
  newAdminBidRequestsUrl: 'https://admin.carvector.com/auctions/requests',
  newAdminTranslationsUrl: 'https://admin.carvector.com/auctions/translations',
  newAdminContentUrl: 'https://admin.carvector.com/auctions/content',
  newAdminHistoryUrl: 'https://admin.carvector.com/auctions/history',
  newAdminUsersUrl: 'https://admin.carvector.com/auctions/users'
};
